const UPDATE_COMPARISON = (state, payload) => {
  state.comparison = payload
}

const UPDATE_COMPARISON_STATUS = (state, payload) => {
  state.comparison.status = payload
}

const UPDATE_WINNER_VIDEO = (state, payload) => {
  state.comparison.winner_video_id = payload
}

const UPDATE_COMPARISON_NAME = (state, payload) => {
  state.comparison.name = payload
}

const UPDATE_COMPARISON_VIDEOS_LIST = (state, payload) => {
  state.comparison.videos = payload
}

export {
  UPDATE_COMPARISON,
  UPDATE_COMPARISON_STATUS,
  UPDATE_WINNER_VIDEO,
  UPDATE_COMPARISON_NAME,
  UPDATE_COMPARISON_VIDEOS_LIST
}